import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { getContent } from '../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../constants/routerConstant';
import API_NOTIFICATION from '../../api/apiNotification';
import BackButton from '../../components/Common/BackButton';
import NextPageButton from '../../components/Common/NextPageButton';
import PreviousPageButton from '../../components/Common/PreviousPageButton';
import TicketPage from '../../components/Common/TicketPage';
import IconNotification from '../../assets/icons/IconNotification';
import { CheckPermissionComponent } from '../../util/permission';
import { NOTIFICATION_VIEW } from '../../constants/menuPermissionConstant';

class Notification extends Component {
    constructor(props) {
        super(props);
        this.state = {
            notification: [],
            page: 1,
            limit: 10,
            total: 0,
        }
    }

    getInitiateNotification = () => {
        API_NOTIFICATION.getInitiateNotification(this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        total: getContent(res).count_data
                    })
                }
            })
    }

    getNotification = () => {
        API_NOTIFICATION.getListNotification(this.state.page, this.state.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        notification: getContent(res)
                    })
                }
            })
    }

    handleOpenNotification = async data => {
        if (!data.is_open) {
            const notifData = {
                updated_at: data.created_at
            }
            await API_NOTIFICATION.putReadNotification(notifData, data.id, this.props.token)
        }

        this.props.history.push(`${ROUTER_CONSTANT.TICKET_DETAIL_ALL.split(':')[0]}${data.ticket_id}`)
    }

    handlePreviousPage = async () => {
        if (this.state.page > 1) {
            await this.setState({
                page: this.state.page - 1
            })
            this.getNotification();
        }
    }

    handleNextPage = async () => {
        if (this.state.page * this.state.limit < this.state.total) {
            await this.setState({
                page: this.state.page + 1
            })
            this.getNotification();
        }
    }

    componentDidMount() {
        this._isMounted = true;
        this.intervalId = setInterval(() => this.getNotification(), 300000);
        this.getInitiateNotification();
        this.getNotification();
    }

    componentWillUnmount() {
        this._isMounted = false;

        clearInterval(this.intervalId);
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[NOTIFICATION_VIEW]} userPermission={this.props.userDetail.permissions}>
                <div className="notification">
                    <div className="header flex justify-between mb-5">
                        <div className="flex items-center">
                            <BackButton />
                            <p className="text-darkblue font-medium text-2xl">Notifikasi</p>
                        </div>
                        <div className="flex items-center text-sm">
                            <TicketPage page={this.state.page} limit={this.state.limit} total={this.state.total} />
                            <div id="btnpreviouspage" onClick={() => this.handlePreviousPage()}><PreviousPageButton /></div>
                            <div id="btnnextpage" onClick={() => this.handleNextPage()}><NextPageButton /></div>
                        </div>
                    </div>
                    <div className="calculate-layout-button">
                        <div className="h-full overflow-auto">
                            {
                                this.state.notification.length > 0
                                    ? <>
                                        {
                                            this.state.notification.map((notif, idx) =>
                                                <div key={idx} className="bg-white rounded-xl mb-3 overflow-hidden">
                                                    <div className="bg-darkgrey text-gray-700 font-medium px-14 py-3">{notif.date}</div>
                                                    {
                                                        notif.notifications.map((notifMessage, idx2) =>
                                                            <div className="pt-3 px-10 hover:bg-blue-100 cursor-pointer" key={idx2} id="btnopennotification" onClick={() => this.handleOpenNotification(notifMessage)}>
                                                                <div className={notif.notifications.length === idx2 + 1 ? "pb-3 px-4 text-gray-700 flex justify-between" : "pb-3 px-4 text-gray-700 flex justify-between border-b-2 border-gray"}>
                                                                    <div className="w-10/12">
                                                                        <p className={notifMessage.is_open ? null : "font-bold"}>Pesan baru dari tiket {notifMessage.ticket_no} oleh {notifMessage.message_from}.</p>
                                                                        <p className="text-sm">{notifMessage.message}</p>
                                                                    </div>
                                                                    <div className="w-2/12 text-right text-sm">
                                                                        <p>{moment.utc(notifMessage.created_at).format('DD/MM/YYYY HH:mm')}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                            )
                                        }
                                    </>
                                    :
                                    <div className="flex flex-col justify-center items-center h-full">
                                        <IconNotification />
                                        <p className="text-2xl text-darkblue opacity-30 mt-5">Tidak Ada Notifikasi</p>
                                    </div>
                            }
                        </div>
                    </div>
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

export default connect(mapStateToProps, null)(Notification);